module.exports = __webpack_public_path__ + "static/media/banner-harineradechiapas.a92c68ae.jpg";